export default __webpack_public_path__ + "static/media/SG7.8edf4f39.png";